<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__user">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="账号：">
          <el-input v-model="dataForm.username" :placeholder="$t('user.username')" clearable></el-input>
        </el-form-item>
        <el-form-item label="姓名：">
          <el-input v-model="dataForm.realName" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:user:save')" type="primary" @click="addOrUpdateHandle()">{{
              $t('add')
            }}
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
          v-loading="dataListLoading"
          :data="dataList"
          border
          @selection-change="dataListSelectionChangeHandle"
          @sort-change="dataListSortChangeHandle"
          style="width: 100%;">
        <el-table-column type="index" label="#" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="username" :label="$t('user.username')" sortable="custom" header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="realName" label="姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="mobile" :label="$t('user.mobile')" sortable="custom" header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="status" :label="$t('user.status')" sortable="custom" header-align="center" width="80"
                         align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" size="small" type="danger">{{ $t('user.status0') }}</el-tag>
            <el-tag v-else size="small" type="success">{{ $t('user.status1') }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" :label="$t('user.createDate')" sortable="custom" header-align="center"
                         align="center" width="160"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="200">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:user:update')" type="text" size="small"
                       icon="el-icon-edit-outline"
                       @click="showUserChange(scope.row.id)">账号交接
            </el-button>
            <el-button v-if="$hasPermission('sys:user:update')" type="text" size="small"
                       icon="el-icon-edit-outline"
                       @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
            </el-button>
            <el-button v-if="$hasPermission('sys:user:delete')" type="text" size="small"
                       icon="el-icon-close"
                       @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
            </el-button>
            <el-button v-if="$hasPermission('sys:user:delete')" type="text" size="small"
                       icon="el-icon-close"
                       @click="freeze(scope.row)">{{ scope.row.status === 1 ? '冻结帐号' : '解冻帐号' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <UserChange ref="UserChange" @refreshDataList="getDataList"></UserChange>
    </div>
  </el-card>
</template>

<script>
import UserChange from '@/views/modules/sys/user-change.vue'
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './user-add-or-update'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/user/page',
        getDataListIsPage: true,
        deleteURL: '/sys/user',
        deleteIsBatch: true,
        exportURL: '/sys/user/export'
      },
      dataForm: {
        username: '',
        realName: ''
      }
    }
  },
  methods: {
    async freeze (row) {
      let msg = `是否${row.status === 1 ? '冻结' : '解冻'}${row.realName}的帐号?`
      try {
        await this.$confirm(msg)
        await this.$api2.post(`/sys/user/freeze/${row.id}`)
        this.$message.success('操作成功')
        this.getDataList()
      } catch (e) {
        console.log(e)
      }
    },
    showUserChange (id) {
      this.$refs.UserChange.dataForm.id = id
      this.$refs.UserChange.init()
    }
  },
  components: {
    AddOrUpdate, UserChange
  }
}
</script>
